var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminLandingProgress"},_vm._l((this.totalSteps),function(index){return _c('div',{key:index,class:[
      'progress',
      { current: _vm.currentStep === index, completed: _vm.currentStep > index }
    ]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }